"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _height = _interopRequireDefault(require("../run/height"));
/**
 * Returns attributed string height
 *
 * @param {Object} attributed string
 * @return {number} height
 */


var height = function height(attributeString) {
  var reducer = function reducer(acc, run) {
    return Math.max(acc, (0, _height["default"])(run));
  };

  return attributeString.runs.reduce(reducer, 0);
};

var _default = height;
exports["default"] = _default;